export const ADMIN_AIMANTRA_ROLES = [
  "Admin_AiMantra",
  "Admin_Aimantra",
  "SuperAdmin_AiMantra",
  "SuperAdmin_Aimantra",
];

export const SUPERADMIN_AIMANTRA_ROLES = [
  "SuperAdmin_AiMantra",
  "SuperAdmin_Aimantra",
];

export const isAdminAiMantraRole = (role) =>
  ADMIN_AIMANTRA_ROLES.includes(String(role || ""));

export const isSuperAdminAiMantraRole = (role) =>
  SUPERADMIN_AIMANTRA_ROLES.includes(String(role || ""));

export const adminAiMantraPathPrefix = (role) => {
  const value = String(role || "");
  if (ADMIN_AIMANTRA_ROLES.includes(value)) {
    return value;
  }
  return "Admin_AiMantra";
};

export const roleAllowed = (userRole, allowedRoles) => {
  if (userRole === allowedRoles) return true;
  if (Array.isArray(allowedRoles) && allowedRoles.includes(userRole)) {
    return true;
  }
  if (isAdminAiMantraRole(userRole) && isAdminAiMantraRole(allowedRoles)) {
    return true;
  }
  return false;
};

export const findRouteForRole = (routingData, role) => {
  const exact = routingData.find((entry) => entry.role === role);
  if (exact) return exact;
  if (isAdminAiMantraRole(role)) {
    return routingData.find((entry) => entry.role === "Admin_AiMantra");
  }
  return undefined;
};
